/**
 * Created by david on 2017/4/26.
 */

class TempStorage {
    constructor() {
        this.storage = {};
    }

    getItem(key) {
        if (key in this.storage) {
            return this.storage[key];
        }
        return null;
    }

    setItem(key, value) {
        this.storage[key] = value;
        return true;
    }

    removeItem(key) {
        if (key in this.storage) {
            delete this.storage[key];
        }
        return true;
    }

    clear() {
        this.storage = {};
    }
}


class StorageService {
    sign = 'v1';

    constructor(drive = 'session') {

        let drives = {
            'local': window.localStorage,
            'session': window.sessionStorage,
            'temp': new TempStorage()
        }
        if (drive in drives) {
            this.storage = drives[drive];
        } else {
            throw new Error('storage no map dirves');
        }
    }

    has(key) {
        return this.storage.getItem(this.sign + key) !== null;
    }

    get(key) {
        let obj = this.storage.getItem(this.sign + key);
        if (obj !== null) {
            obj = JSON.parse(obj).data;
        }
        return obj;
    }

    set(key, value, exprie) {
        let sdata = {data: value, exprie: exprie}
        return this.storage.setItem(this.sign + key, JSON.stringify(sdata));
    }

    clear() {
        this.storage.clear();
    }
}


export default StorageService;



// WEBPACK FOOTER //
// ./src/services/StorageService.js